import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "14",
  fill: "none",
  viewBox: "0 0 17 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m6.616 1.35-.6.45zm0 0-.6.45.975 1.3.6-.45.6-.45L7.216.9zm2.175 1.9V4h5.875V2.5H8.791zm7.375 1.5h-.75v7h1.5v-7zm-1.5 8.5v-.75H2.25V14h12.416zM.75 11.75h.75v-9.5H0v9.5zm1.5-11v.75h3.166V0H2.25zm-1.5 1.5h.75a.75.75 0 0 1 .75-.75V0A2.25 2.25 0 0 0 0 2.25zm1.5 11v-.75a.75.75 0 0 1-.75-.75H0A2.25 2.25 0 0 0 2.25 14zm13.916-1.5h-.75a.75.75 0 0 1-.75.75V14a2.25 2.25 0 0 0 2.25-2.25zm-1.5-8.5V4a.75.75 0 0 1 .75.75h1.5a2.25 2.25 0 0 0-2.25-2.25zm-7.075-.6-.6.45a2.25 2.25 0 0 0 1.8.9V2.5a.75.75 0 0 1-.6-.3zm-.975-1.3.6-.45a2.25 2.25 0 0 0-1.8-.9v1.5a.75.75 0 0 1 .6.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }